import Link from 'next/link';
import {
  BUSINESS_EMAIL_CONTACT_ADDRESS,
  BUSINESS_EMAIL_CONTACT_URL,
  BUSINESS_EMAIL_REQUIRED_MESSAGE,
} from '@/utils/auth/business-email';
import { SSO_REQUIRED_MESSAGE } from '@/utils/auth/sso-copy';

/**
 * Inline signup error. For the business-email rejection it also offers a way to reach the team —
 * parity with the dedicated /business-email-required screen the Google OAuth path redirects to,
 * which the (correctable, in-place) email+password form doesn't need a full redirect for. For an
 * SSO-managed address it offers the sign-in page, where the SSO button is.
 */
export function SignupErrorMessage({ message }: { message: string }) {
  return (
    <div className="text-center text-sm text-red-500">
      <p>{message}</p>
      {message === SSO_REQUIRED_MESSAGE && (
        <p className="mt-1">
          <Link href="/login" className="font-bold underline">
            Go to sign in
          </Link>
        </p>
      )}
      {message === BUSINESS_EMAIL_REQUIRED_MESSAGE && (
        <p className="mt-1">
          Think this is a mistake? Email us at{' '}
          <a href={BUSINESS_EMAIL_CONTACT_URL} className="font-bold underline">
            {BUSINESS_EMAIL_CONTACT_ADDRESS}
          </a>
          .
        </p>
      )}
    </div>
  );
}
